import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import type { ScannedPage } from 'components/Documents/Scanner/types';

interface ScannedPagesGridProps {
  pages: ScannedPage[];
  maxPages: number;
  onRemove: (index: number) => void;
}

const ScannedPagesGrid: React.FC<ScannedPagesGridProps> = ({ pages, maxPages, onRemove }) => {
  if (pages.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant='subtitle1' gutterBottom>
        Scanned pages ({pages.length}/{maxPages})
      </Typography>
      <Grid container spacing={2}>
        {pages.map((page, index) => (
          <Grid item xs={6} sm={4} key={page.id}>
            <Card variant='outlined'>
              <CardContent sx={{ p: 1, textAlign: 'center' }}>
                <Box
                  component='img'
                  src={page.previewUrl}
                  alt={`Scanned page ${index + 1}`}
                  sx={{ width: '100%', borderRadius: 1, display: 'block' }}
                />
                <IconButton
                  color='error'
                  size='small'
                  aria-label={`Delete page ${index + 1}`}
                  onClick={() => onRemove(index)}
                  sx={{ mt: 0.5 }}
                >
                  <DeleteIcon fontSize='small' />
                </IconButton>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ScannedPagesGrid;
